import React from 'react'

import { useSelector } from 'react-redux'
import { selectCurrentMode } from '../../store/itinerary/itinerary.selectors'
import { TextError } from '../genericComponents/TextError'
import { MULTIPATH_MODE_TRAIN } from '../../store/itinerary/itinerary.constants'

const ItineraryTextError = ({ error }) => {
  const currentMode = useSelector(selectCurrentMode)

  if (currentMode === MULTIPATH_MODE_TRAIN) return <></>

  return <TextError error={error} />
}

export default ItineraryTextError
